import {useMediaQuery} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {DashboardLayout} from "@toolpad/core/DashboardLayout";
import {ReactRouterAppProvider} from "@toolpad/core/react-router";
import ChatBubbleIcon from "assets/img/logo_mutexsms.png";
import {useAuthenticatedUser} from "hooks/useAuth";
import {useSetUnits, useUnits} from "hooks/useUnits";
import AccountMenu from "layouts/app/AccountMenu";
import SidebarFooter from "layouts/app/SidebarFooter";
import ToolbarActions from "layouts/app/ToolbarActions";
import {useGetUnitsBalanceQuery} from "pages/dashboard/api";
import {type FC, type PropsWithChildren, useEffect} from "react";
import {Outlet} from "react-router";
import getNavigation from "router/getNavigation";
import {getRoutesForUser} from "router/routes";
import {formatNumber} from "utils/values";

const ToolPadAppShell: FC<PropsWithChildren> = () => {
  const user = useAuthenticatedUser();

  const setUnits = useSetUnits();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const roleBasedRoutes = getRoutesForUser(user);
  const navigation = getNavigation(user!, roleBasedRoutes);

  const {data, loading} = useGetUnitsBalanceQuery({});
  useEffect(() => {
    if (data?.balance !== undefined) {
      setUnits(formatNumber(data.balance));
    }
  }, [data?.balance]);
  const units = useUnits();

  const ToolbarActionsSlot: FC = () => (
    <ToolbarActions loading={loading} units={units} isMobile={isMobile} />
  );

  return (
    <ReactRouterAppProvider
      navigation={navigation}
      theme={theme}
      branding={{
        title: "Mutex SMS",
        logo: <img src={ChatBubbleIcon} alt="Dashboard Icon" />,
      }}>
      <DashboardLayout
        slots={{
          toolbarActions: ToolbarActionsSlot,
          toolbarAccount: AccountMenu,
          sidebarFooter: () => (
            <SidebarFooter
              loading={loading}
              units={units}
              isMobile={isMobile}
            />
          ),
        }}>
        <Outlet />
      </DashboardLayout>
    </ReactRouterAppProvider>
  );
};

export default ToolPadAppShell;
